import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "../Images/Image/Img";
// eslint-disable-next-line import/no-cycle
import { Button as SharedButton } from "../Button";
import * as styles from "./Banner.module.scss";

const Banner = ({ image, link, text, style, className, customButton }) => {
	let Button = null;

	if (customButton) {
		Button = customButton;
	} else {
		Button = SharedButton;
	}

	return (
		<div className={cx(styles.banner, className.bannerCustom)} style={style}>
			{image.url ? (
				<Img alt={image.alt} src={image.url} />
			) : (
				<Img fluid={image.fluid} alt={image.alt} />
			)}
			<div
				className={cx(styles.bannerContent, className.bannerCustomContent)}
				style={link ? { left: "rem(-50%)" } : { left: "0" }}>
				{link.url && (
					<Button
						to={link.url}
						target={link?.linkTarget}
						label={link?.linkText}
						theme="wedding"
						size="md"
						className={cx(styles.bannerBtn)}
					/>
				)}
				<div
					className={cx(styles.bannerText, className.bannerCustomText)}
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			</div>
		</div>
	);
};

Banner.propTypes = {
	image: PropTypes.shape({
		url: PropTypes.string,
		alt: PropTypes.string,
		srcSet: PropTypes.object,
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	}).isRequired,
	link: PropTypes.shape({
		url: PropTypes.string,
		linkText: PropTypes.string,
		linkTarget: PropTypes.string,
	}),
	text: PropTypes.string.isRequired,
	className: PropTypes.object,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	customButton: PropTypes.func,
};

Banner.defaultProps = {
	link: {},
	className: "",
	style: {},
	customButton: null,
};

export default Banner;
export { Banner };
